<template>
      <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>经营站点设置</span>
                        </div>
                        <div class="conf siteConf">
                            <el-form label-position="top" :inline="true" style="width:800px;">
                                <el-form-item v-for="shop in shopList" :label="shop.shortTitle || shop.title" :key="shop.id">
                                    <el-select v-model="siteValueMap[shop.id]" placeholder="请选择" filterable multiple collapse-tags value-key="siteId" width="350px">
                                        <el-option v-for="item in siteList" :key="item.siteId" :label="item.siteName" :value="item"></el-option>
                                    </el-select>
                                    <div class="tips">选择站点后，在下方发货仓与库存设置中配置各站点发货仓</div>
                                </el-form-item>
                            </el-form>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="中文标题超长自动截断:" >
                                <el-checkbox v-model="checked">商品标题超过平台限制自动截断（最多500个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="英文标题超长自动截断:" >
                                <el-checkbox v-model="checked">商品标题超过平台限制自动截断（最多500个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="款式编码取值规则:" >
                                <el-radio-group v-model="checked">
                                    <el-radio :label="3">平台商品ID</el-radio>
                                    <el-radio :label="6">货号</el-radio>
                                    <el-radio :label="9">款号</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <!-- <el-form-item label="规格图调整时规格预览图:" >
                                <el-radio-group v-model="checked">
                                    <el-radio :label="3">变更</el-radio>
                                    <el-radio :label="6">不变更<span style="font-size:10px;color:#ccc;">不变更时，TEMU规格图调整不影响预览图</span></el-radio>
                                </el-radio-group>
                            </el-form-item> -->
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>发货仓与库存设置</span>
                        </div>
                        <div class="conf" style="width:60%;">
                            <SendWarehouse :shopList="shopList" />
                        </div>
                    </section>
                </el-form>
            </div>
        </div>
      </div>
</template>

<script>
import '@/assets/css/prod.scss';
import shopListMixin from '@/components/prod/center/components/shopListMixin';
import { getSites } from '@/servers/prod/center/temu.js';
import SendWarehouse from '@/components/prod/center/components/TemuSemiInfoForm/components/SendWarehouse.vue'

const PLATFORMID = 'pddtemu';
export default {
    mixins: [shopListMixin],
    props: {
        back: Function
    },
    components: {
        SendWarehouse,
    },
    data() {
        return {
            platform:'pddtemu_btg',
            siteList:[],
            value: {
                a:''
            },
            siteValueMap:{},
            rules: {
                // instock: [
                //     {required: true, message: '请输入库存数'},
                //     {validator: validateInstock}
                // ],
            },
            checked:false,
        }
    },
    computed:{
        shopList(){
            return this.getShopList(this.platform);
            // return this.$store.getters.get_AllShops_BySource(this.platform)
        },
    },
    methods: {
        initSite(){
            this.geSiteList();
            let map = {}
            this.shopList.forEach(shop => {
                map[shop.id] = []
            });
            this.siteValueMap = map
        },
        // 获取经营站点
        geSiteList(keyword){
            let params = {
                keyword:''
            }
            getSites(params).then(res => {
                if(res){
                    this.siteList = res
                }
            })
        },
    },
    mounted() {},
    created(){
        this.initSite();
    }
}
</script>

<style lang="scss" scoped>
.conf-wrp{
  .siteConf{
    ::v-deep .el-form--label-top .el-form-item__label{
        padding: 0;
    }
  }
  .tips{
    font-size: 12px;
    color: #909399;
  }
}
</style>